import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import {
  FEED_POSTS_LIST,
  FEED_POST_DELETE,
  FEED_POST_COMMENTS,
  FEED_POST_LIKES,
  POSTS_CATEGORY_LIST_DROPDOWN,
  USER_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, LEAD_DELETED } from "../../constant/constant";
import {  
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole,
} from "../../components/Utils";
import Loader from "../../components/common/Loader";
import CommentItem from "./CommentItem";
import { Modal, Image } from "react-bootstrap";
import ModalImage from "react-modal-image";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { Link } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import { glassSelectStyles } from "../../constant/selectStyles";

const FeedPostsList = () => {
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [likesData, setLikesData] = useState([]);
  const [likesLoading, setLikesLoading] = useState(false);
  const [commentsData, setCommentsData] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);

  const [filter, setFilter] = useState({
    country_id: null,
    state_id: null,
    region_id: null,
    chapter_id: null,
    posted_by: null,
    from_date: "",
    to_date: "",
    post_type: null,
  });

  const [userOptions, setUserOptions] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});

  const [showClearBtn, setShowClearBtn] = useState(false);

  const refFlatpickr = useRef(null);
  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const { hasPermission } = usePermission();

  const HandleDelete = async (id) => {
    try {
      axios.delete(FEED_POST_DELETE + id).then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(LEAD_DELETED);
          setRefresh((prev) => !prev);
        }
      });
    } catch (error) {
      console.error("Error deleting Lead:", error);
    }
  };

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    if (refFlatpickr.current && refFlatpickr.current.flatpickr) {
      refFlatpickr.current.flatpickr.setDate([]);
    }
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(FEED_POSTS_LIST, {
        params: {
          type: PAGINATE,
          paging_type: "paginate",
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.feed_posts);
          setPaginator({
            prev: response.data.data.prev != null,
            next: response.data.data.next != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .catch((err) => {
        toast.error("Error fetching Lead");
      })
      .finally(() => {
        setLoading(false);
      });

    const fetchData = async () => {
      try {
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: { ...filter, exclude_other_region_chapter_users: 1 },
        });
        setUserOptions(userResponse.data.data);

        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        setCountryOptions(countryResponse.data.data);

        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setStateOptions(stateResponse.data.data);

        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setRegionOptions(regionResponse.data.data);

        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setChapterOptions(chapterResponse.data.data);

        const categoryResponse = await axios.get(POSTS_CATEGORY_LIST_DROPDOWN);
        setCategoryOptions(categoryResponse.data.data);
      } catch (error) {
        console.error("Error fetching dependencies:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  const openDetailsModal = async (post) => {
    setDetailData(post);
    setLikesData([]);
    setCommentsData([]);
    setDetailModal(true);
    setLikesLoading(true);
    setCommentsLoading(true);
    try {
      const responseComments = await axios.get(
        `${FEED_POST_COMMENTS}${post.id}`,
      );
      if (responseComments.status === 200 && responseComments.data.success) {
        setCommentsData(responseComments.data.data.comments || []);
      }

      const responseLikes = await axios.get(`${FEED_POST_LIKES}${post.id}`);
      if (responseLikes.status === 200 && responseLikes.data.success) {
        setLikesData(responseLikes.data.data.liked_users || []);
      }
    } catch (err) {
      toast.error("Failed to load likes and comments.");
    } finally {
      setLikesLoading(false);
      setCommentsLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-3">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Lead</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Lead List</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="filter-card">
          <h6 className="filter-card-title">Search &amp; Filter</h6>

            <div className="row mb-4 gx-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3">
                  <label className="filter-label">Category</label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="post_type"
                    isClearable
                    options={categoryOptions}
                    onChange={(selected) =>
                      setFilter({
                        ...filter,
                        post_type: selected?.value || null,
                      })
                    }
                    placeholder="All Categories"
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3">
                  <label className="filter-label">User</label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="posted_by"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({
                        ...filter,
                        posted_by: selected?.value || null,
                      })
                    }
                    placeholder="All Users"
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="filter-label" htmlFor="date_range">
                    Date Range
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

        <div className="card icard sticky-table-card">
          


          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Topic / Category</th>
                  <th>Image</th>
                  <th>Description</th>
                  <th>User</th>
                  <th>Likes</th>
                  <th>Comments</th>
                  <th>Date</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="9" />
                ) : data.length > 0 ? (
                  data.map((post, i) => (
                    <tr key={i}>
                      <td>{post?.sno}</td>
                      <td>{post?.post_type_name}</td>
                      <td>
                        {post?.post_image ? (
                          <a
                            href={post?.post_image}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Image
                              width={80}
                              height={60}
                              src={post?.post_image}
                              style={{ objectFit: "cover" }}
                            />
                          </a>
                        ) : (
                          <small>No Preview Image</small>
                        )}
                      </td>
                      <td
                        style={{
                          maxWidth: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {post?.description}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="table_img pr-2">
                            <img src={post?.posted_by_image} alt="user" />
                          </span>
                          <span>{post?.posted_by_name}</span>
                        </div>
                      </td>
                      <td>{post?.likes_count}</td>
                      <td>{post?.comments_count}</td>
                      <td>{post?.created_at}</td>
                      <td style={{ textAlign: "center" }}>
                        {hasPermission("feed-posts-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            title="View"
                            onClick={() => openDetailsModal(post)}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}
                        {hasPermission("feed-posts-edit") && (
                          <Link to={`/feed-posts/${post.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("feed-posts-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(post?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="9" message="No Lead found" />
                )}
              </tbody>
            </table>
          </StickyTable>

          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={detailsModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal_title1">Lead Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Member</label>
                  <div className="d-flex align-items-center mt-1">
                    <span className="table_img pr-2">
                      <img
                        src={detailData?.posted_by_image}
                        alt="user"
                        className="rounded-circle"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                        }}
                      />
                    </span>
                    <span className="font-weight-600">
                      {checkEmptyOrNull(detailData?.posted_by_name)}
                    </span>
                    &nbsp;
                    <span>-</span>&nbsp;
                    <span className="font-weight-600">
                      {checkEmptyOrNull(detailData?.posted_by_company_name)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Category / Topic</label>
                  <span className="d-block font-weight-600 mt-1">
                    {checkEmptyOrNull(detailData?.post_type_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Metrics</label>
                  <span className="d-block font-weight-600 mt-1">
                    <i className="bx bx-like text-primary me-1"></i>{" "}
                    {detailData?.likes_count || 0} Likes &nbsp;&nbsp;&nbsp;
                    <i className="bx bx-message text-success me-1"></i>{" "}
                    {detailData?.comments_count || 0} Comments
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Created At</label>
                  <span className="d-block font-weight-600 mt-1">
                    {checkEmptyOrNull(detailData?.created_at)}
                  </span>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-4">
                  <label className="form-label m-0">Description</label>
                  <span
                    className="d-block font-weight-600 mt-1"
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {checkEmptyOrNull(detailData?.description)}
                  </span>
                </div>
              </div>

              {detailData?.post_image && (
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label mb-2">Image</label>

                    {detailData.post_image !== "" ? (
                      <span className="d-block font-weight-600">
                        <ModalImage
                          small={detailData.post_image}
                          large={detailData.post_image}
                          alt="Lead Image"
                          showRotate
                          hideDownload={true}
                        />
                      </span>
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              )}
            </div>

            <hr />
            <div className="row">
              <div className="col-md-12">
                <h6 className="mb-3 text-primary">
                  Likes ({detailData?.likes_count})
                </h6>
                {likesLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border spinner-border-sm text-primary"
                      role="status"
                    ></div>{" "}
                    Loading Likes...
                  </div>
                ) : likesData && likesData.length > 0 ? (
                  <div
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                    className="px-2"
                  >
                    {likesData.map((like, idx) => (
                      <div
                        key={idx}
                        className="d-flex align-items-center justify-content-between mb-2"
                      >
                        <div className="d-flex align-items-center">
                          <div
                            className="avatar avatar-md rounded-circle bg-gray-200 d-flex align-items-center justify-content-center overflow-hidden me-3"
                            style={{ width: "40px", height: "40px" }}
                          >
                            {like.user_profile_image ? (
                              <Image
                                src={like.user_profile_image}
                                alt="User"
                                className="w-100 h-100 object-fit-cover"
                              />
                            ) : (
                              <span className="text-muted fs-6">
                                {like.name?.charAt(0).toUpperCase() || "U"}
                              </span>
                            )}
                          </div>
                          <div className="font-weight-600 text-gray-900">
                            {like.name}
                          </div>
                        </div>
                        <div className="small">{like.liked_at}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-muted py-3">
                    No likes yet.
                  </div>
                )}
              </div>
            </div>

            <hr />
            <div className="row">
              <div className="col-md-12">
                <h6 className="mb-3 text-primary">
                  Comments ({detailData?.comments_count})
                </h6>
                {commentsLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border spinner-border-sm text-primary"
                      role="status"
                    ></div>{" "}
                    Loading Comments...
                  </div>
                ) : commentsData && commentsData.length > 0 ? (
                  <div
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                    className="px-2"
                  >
                    {commentsData.map((cmt, idx) => (
                      <CommentItem key={idx} cmt={cmt} depth={0} />
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-muted py-3">
                    No comments yet.
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#163586"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                setConfirmationModal(false);
                confirmation?.fn?.();
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FeedPostsList;
